import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Settings, LogOut, ChevronDown } from 'lucide-react';
import { NotificationBell } from './NotificationBell';
import { useAuth } from '../contexts/AuthContext';

export function AppHeader() {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    setShowMenu(false);
    if (window.confirm('Are you sure you want to sign out?')) {
      await logout();
      navigate('/login');
    }
  };

  const handleSettings = () => {
    setShowMenu(false);
    navigate('/settings');
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-surface border-b border-border z-50 px-4 py-2">
      <div className="max-w-2xl mx-auto flex items-center justify-between">
        <h1 className="text-lg font-semibold text-foreground">Photog Bizkit</h1>
        
        <div className="flex items-center gap-2">
          <NotificationBell />
          
          {/* User Menu */}
          <div className="relative" ref={menuRef}>
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="flex items-center gap-1 px-2 py-1.5 rounded-lg hover:bg-surface-raised transition-colors"
              data-testid="user-menu-button"
            >
              <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center">
                <User className="w-4 h-4 text-primary" />
              </div>
              <ChevronDown className={`w-3 h-3 text-text-muted transition-transform ${showMenu ? 'rotate-180' : ''}`} />
            </button>

            {showMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-surface border border-border rounded-lg shadow-lg overflow-hidden">
                <div className="px-4 py-3 border-b border-border">
                  <p className="text-xs text-text-muted">Signed in as</p>
                  <p className="text-sm text-foreground font-medium truncate">{user?.email || 'User'}</p>
                </div>
                
                <button
                  onClick={handleSettings}
                  className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-surface-raised transition-colors text-left"
                  data-testid="menu-settings"
                >
                  <Settings className="w-4 h-4 text-text-muted" />
                  <span className="text-sm text-foreground">Settings</span>
                </button>
                
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-alert/10 transition-colors text-left border-t border-border"
                  data-testid="menu-logout"
                >
                  <LogOut className="w-4 h-4 text-alert" />
                  <span className="text-sm text-alert font-medium">Sign Out</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
